import React, { FC } from 'react';

import { Container } from '@lglp/components';

import styles from './PerformancesIcon.module.scss';

const PerformancesIcon: FC<PerformancesIconProps> = ({
  className,
  ...rest
}) => {
  return (
    <Container className={[styles.container, className]} {...rest}>
      <Container className={styles.footerGraph}>
        <span className={styles.footerGraphItem}>&nbsp;</span>
        <span className={styles.footerGraphItem}>&nbsp;</span>
        <span className={styles.footerGraphItem}>&nbsp;</span>
      </Container>
    </Container>
  );
};

type PerformancesIconProps = {
  className?: string;
};

export default PerformancesIcon;
